import { styled } from '@mui/material/styles'

import { useTranslation } from 'react-i18next'

import LogoIcon from './assets/logo-dark.svg'
import LogoLightIcon from './assets/logo-light.svg'
import ImageWithFailOver from './ImageWithFailOver'

import { useAuth } from '../hooks/use-auth'

const ThemeLogo = styled((props) => {
    const { t } = useTranslation()

    const contextUser = useAuth()
    const { variant, customHeadlineImageEnabled, ...other } = props

    const hasCustomHeadlineImageEnabled =
        typeof customHeadlineImageEnabled != 'undefined'

    const color = variant === 'light' ? '#C1C4D6' : '#5048E5'

    const { userDefaultNetwork, userNetworks } = contextUser

    const matchedNetwork = userNetworks.find(
        (userNetwork) => userNetwork.network_id === userDefaultNetwork
    )
    const matchedUser = matchedNetwork
        ? matchedNetwork
        : userNetworks.length
          ? userNetworks[0]
          : {}

    if (hasCustomHeadlineImageEnabled) {
        if (customHeadlineImageEnabled) {
            return (
                <ImageWithFailOver
                    src={`${matchedUser.usr_logo_url}`}
                    loading="lazy"
                    style={{ maxWidth: 230, maxHeight: 40 }}
                />
            )
        }
    } else {
        if (matchedUser && matchedUser.usr_logo_url) {
            return (
                <ImageWithFailOver
                    src={`${matchedUser.usr_logo_url}`}
                    loading="lazy"
                    style={{ maxWidth: 230, maxHeight: 40 }}
                />
            )
        }
    }

    return variant === 'light' ? (
        <LogoLightIcon {...other} />
    ) : (
        <LogoIcon color={color} {...other} />
    )
})``

ThemeLogo.defaultProps = {
    variant: 'primary'
}

export default ThemeLogo
